import { CollapseProps } from 'antd';
import { FormikProps } from 'formik';

import { MFilter } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import { DateRange, MultiSelect, TextArea } from '@Components/Filters';

import { FilterForm } from './types';
import {
  getReasonLabels,
  getStatusLabels,
} from '../store/selectors/resignationRequestSelector';

interface FiltersProps {
  formik: FormikProps<FilterForm>;
  showError?: boolean;
}

const Filters: React.FC<FiltersProps> = ({ formik, showError = false }) => {
  const statuses = useAppSelector(getStatusLabels);
  const reasons = useAppSelector(getReasonLabels);

  const items: CollapseProps['items'] = [
    {
      id: 'RESIGNATION DATE RANGE',
      label: 'Resignation Date Range',
      children: (
        <DateRange<FilterForm>
          formik={formik}
          fromKey="resignationDateFrom"
          toKey="resignationDateTo"
        />
      ),
    },
    {
      id: 'LAST WORKING DATE RANGE',
      label: 'Last Working Date Range',
      children: (
        <DateRange<FilterForm>
          formik={formik}
          fromKey="lastWorkingDateFrom"
          toKey="lastWorkingDateTo"
        />
      ),
    },
    {
      id: 'LETTER OF CONTENT',
      label: 'Letter of Content',
      children: (
        <TextArea<FilterForm> formik={formik} formikKey="letterOfContent" />
      ),
    },
    {
      id: 'REASON',
      label: 'Reason',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="reason"
          options={reasons}
        />
      ),
    },
    {
      id: 'STATUS',
      label: 'Status',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="statuses"
          options={statuses}
          showSearch
        />
      ),
    },
  ];

  return (
    <MFilter<FilterForm> showError={showError} formik={formik} items={items} />
  );
};

export default Filters;
